import React, { useMemo } from 'react';
import { Card, Grid, SelectField } from 'ui-toolkit';
import { DisplaySolarPanels } from 'ui-toolkit/orders/interfaces/eSolarPanels';
import { NewOrderSpaceWrapping } from './wrappers/NewOrderSpaceWrapper';
import { optionsFromDisplay } from '../../ui-toolkit/enums/optionsFromDisplay';
import { EditAddressDataEntry } from '../../ui-toolkit/orders/components/EditPropertyAddress/EditAddressDataEntry';

export const PropertyAddressForm = () => {
  const solarPanelOptions = useMemo(() => optionsFromDisplay(DisplaySolarPanels), []);
  return (
    <NewOrderSpaceWrapping>
      <Card title="Property Information">
        <Grid>
          <EditAddressDataEntry name={'propertyAddress'} isRequired isCamelCase />
          <Grid templateColumns="1fr 4fr">
            <SelectField label={'Solar Panels'} name={`solarPanels`} options={solarPanelOptions} isClearable />
          </Grid>
        </Grid>
      </Card>
    </NewOrderSpaceWrapping>
  );
};
